import React from "react";
import { Tag } from "antd";
import styles from "./UiPrimitives.module.css";

const toneClassMap = {
  neutral: styles.toneNeutral,
  info: styles.toneInfo,
  success: styles.toneSuccess,
  warning: styles.toneWarning,
  danger: styles.toneDanger,
};

const sizeClassMap = {
  sm: styles.uiTagSm,
  md: styles.uiTagMd,
};

const UiTag = ({
  tone = "neutral",
  size = "sm",
  className,
  style,
  children,
  ...props
}) => {
  const classNames = [
    styles.uiTag,
    toneClassMap[tone] || toneClassMap.neutral,
    sizeClassMap[size] || sizeClassMap.sm,
    className || "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Tag className={classNames} style={style} {...props}>
      {children}
    </Tag>
  );
};

export default UiTag;
